import React from 'react';

function LeftSide(props) {
  return (
    <div className="new_company_settings_container-left_side">
      {props?.children}
    </div>
  );
}

export default LeftSide;
